
import { defineComponent } from "vue";
import api, { Employee } from "../../api/backend-api";
import { AxiosError } from "axios";
import ErrorBlock from "@/components/ErrorBlock.vue";

interface State {
  msg: string;
  employee: Employee;
  errors: AxiosError[];
}

export default defineComponent({
  name: "SheqsyEmployeeForm",
  components: { ErrorBlock },
  mounted() {
    this.$nextTick(() => {
      this.callGetEmployee();
    });
  },
  data: (): State => {
    let employee = { } as Employee;
    return {
      msg: "Sheqsy Employee",
      employee: employee,
      errors: [],
    };
  },
  methods: {
    callCreate() {
      this.errors = [];
      const saveButton = document.getElementById('save')

      if (!this.employee.EmployeeUId || this.employee.EmployeeUId.length < 36) {
        this.errors.push({"message": "Employee UID must be set"} as AxiosError)
      }

      if (this.employee.CompanyUId && this.employee.CompanyUId.length < 36) {
        this.errors.push({"message": "Company UID is invalid"} as AxiosError)
      }

      if (this.errors.length != 0) {
        if (saveButton) {
          saveButton.classList.toggle('disabled')
          saveButton.textContent = 'create'
        }
        return
      }
      this.employee.id = '';
      api
        .createEmployee(this.employee)
        .then((response) => {
          this.employee = response.data
          this.$router.push('/sheqsy/employee/'+response.data.EmployeeUId)
          if (saveButton) {
            saveButton.classList.toggle('disabled')
            saveButton.textContent = 'save'
          }
        })
        .catch((error: AxiosError) => {
          this.employee.id = ':';
          this.errors.push(error.response?.data.message);
          if (saveButton) {
            saveButton.classList.toggle('disabled')
            saveButton.textContent = 'create'
          }
        });
    },
    callSave() {
      this.errors = [];
      const saveButton = document.getElementById('save')
      if (saveButton) {
        saveButton.classList.toggle('disabled')
        saveButton.textContent = '...'
      }

      if (this.employee.id == ':') {
        return this.callCreate()
      }
      api
        .saveEmployee(this.employee)
        .then((
        ) => {
          this.$router.go(0)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
          if (saveButton) {
            saveButton.classList.toggle('disabled')
            saveButton.textContent = 'save'
          }
        });
    },
    callDelete() {
      this.errors = [];
      api
        .deleteEmployee(this.employee.EmployeeUId)
        .then((
        ) => {
          this.$router.push('/sheqsy/employee')
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
    callGetEmployee() {

      this.errors = [];
      let employee_id = '';
      if (typeof this.$route.params.slug != 'string') {
        throw new Error("Invalid url");
      }
      employee_id = this.$route.params.slug

      if (employee_id == ':') {
        this.employee.id = ':';
        this.employee.Departments = [];
        return
      }

      api
        .getEmployee(employee_id)
        .then((response) => {
          this.employee = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
  }
});
